export enum PATHS {
  home = "/",
  swap = "/swap",
  market = "/market",
  profile = "/profile",
}
